import { combineReducers } from 'redux';
import templatesReducer from './templatesSlice';
import sendersReducer from './sendersSlice';

export default combineReducers({
  templates: templatesReducer,
  senders: sendersReducer,
})
